import {
    faAddressCard,
    faComment,
    faComments,
    faPuzzlePiece,
    faPizzaSlice,
    faScrewdriverWrench,
    faCode,
    faBowlFood,
    faMugHot,
    faHeadset,
    faFilePowerpoint,
    faPersonChalkboard,
    faAward,
    faMusic,
    faHourglassEnd,
    faChampagneGlasses,
    faDoorClosed,
    faCookie,
    faUtensils,
    faCloudSun,
    faBreadSlice,
    faBowlingBall,
    faFlagCheckered,
    faUsersLine,
    faCrown,
} from '@fortawesome/free-solid-svg-icons';

export const days = [
    {
        id: 0,
        date: '2023-10-20',
        dayOfWeek: 'Friday',
    },
    {
        id: 1,
        date: '2023-10-21',
        dayOfWeek: 'Saturday',
    },
    {
        id: 2,
        date: '2023-10-22',
        dayOfWeek: 'Sunday',
    },
];

export const eventsData = [
    {
        country: 'Germany',
        schedule: {
            friday: [
                {
                    id: 0,
                    startTime: '2023-10-20T09:00:00',
                    endTime: '2023-10-20T10:00:00',
                    description: 'Registration & Check-In',
                    icon: faAddressCard,
                },
                {
                    id: 1,
                    startTime: '2023-10-20T10:00:00',
                    endTime: '2023-10-20T11:00:00',
                    description: 'Welcome Speeches, Infrastructure & Setup',
                    icon: faComment,
                },
                {
                    id: 2,
                    startTime: '2023-10-20T11:00:00',
                    // endTime: '2023-10-20T00:00:00',
                    description: 'Start of Coding (open end)',
                    icon: faCode,
                },
                {
                    id: 3,
                    startTime: '2023-10-20T12:00:00',
                    endTime: '2023-10-20T13:00:00',
                    description: 'Lunch Break',
                    icon: faBowlFood,
                },
                {
                    id: 4,
                    startTime: '2023-10-20T00:00:00',
                    // endTime: '2023-10-20T00:00:00',
                    description: 'Closing of Venue',
                    icon: faDoorClosed,
                },
            ],
            saturday: [
                {
                    id: 0,
                    startTime: '2023-10-21T09:00:00',
                    endTime: '2023-10-21T09:30:00',
                    description: 'Kick-off Day 2',
                    icon: faMugHot,
                },
                {
                    id: 1,
                    startTime: '2023-10-21T10:30:00',
                    endTime: '2023-10-21T11:15:00',
                    description: 'Call with other venues & games',
                    icon: faHeadset,
                },
                {
                    id: 2,
                    startTime: '2023-10-21T12:00:00',
                    endTime: '2023-10-21T13:00:00',
                    description: 'Lunch Break',
                    icon: faBowlFood,
                },
                {
                    id: 3,
                    startTime: '2023-10-21T14:00:00',
                    endTime: '2023-10-21T17:00:00',
                    description: 'Feedback Sessions',
                    icon: faComments,
                },
                {
                    id: 4,
                    startTime: '2023-10-21T19:00:00',
                    endTime: '2023-10-21T21:00:00',
                    description: 'Dinner & Drinks',
                    icon: faUtensils,
                },
                {
                    id: 5,
                    startTime: '2023-10-21T00:00:00',
                    // endTime: '2023-10-21T00:00:00',
                    description: 'Closing of Venue',
                    icon: faDoorClosed,
                },
            ],
            sunday: [
                {
                    id: 0,
                    startTime: '2023-10-22T09:00:00',
                    endTime: '2023-10-22T09:30:00',
                    description: 'Kick-off Day 3',
                    icon: faMugHot,
                },
                {
                    id: 1,
                    startTime: '2023-10-22T12:00:00',
                    // endTime: '2023-10-22T12:00:00',
                    description: 'End of Coding',
                    icon: faCode,
                },
                {
                    id: 2,
                    startTime: '2023-10-22T12:00:00',
                    endTime: '2023-10-22T13:00:00',
                    description: 'Lunch Break',
                    icon: faBowlFood,
                },
                {
                    id: 3,
                    startTime: '2023-10-22T13:00:00',
                    endTime: '2023-10-22T15:00:00',
                    description: 'Presentation of Results',
                    icon: faPersonChalkboard,
                },
                {
                    id: 4,
                    startTime: '2023-10-22T16:00:00',
                    endTime: '2023-10-22T17:00:00',
                    description: 'Announcement of Winners',
                    icon: faAward,
                },
                {
                    id: 5,
                    startTime: '2023-10-22T17:00:00',
                    endTime: '2023-10-22T19:00:00',
                    description: 'After-party',
                    icon: faChampagneGlasses,
                },
                {
                    id: 6,
                    startTime: '2023-10-22T19:00:00',
                    // endTime: '2023-10-22T19:00:00',
                    description: 'End of Collabothon',
                    icon: faHourglassEnd,
                },
            ],
        },
    },
    {
        country: 'Poland',
        schedule: {
            friday: [
                {
                    id: 0,
                    startTime: '2023-10-20T09:00:00',
                    endTime: '2023-10-20T09:30:00',
                    description: 'Registration',
                    icon: faAddressCard,
                },
                {
                    id: 1,
                    startTime: '2023-10-20T10:00:00',
                    endTime: '2023-10-20T10:30:00',
                    description: 'Introduction & Welcome',
                    icon: faComment,
                },
                {
                    id: 2,
                    startTime: '2023-10-20T10:30:00',
                    endTime: '2023-10-20T11:00:00',
                    description: 'Infrastructure & Setup',
                    icon: faScrewdriverWrench,
                },
                {
                    id: 3,
                    startTime: '2023-10-20T11:00:00',
                    // endTime: '2023-10-20T00:00:00',
                    description: 'Start of Coding (open end)',
                    icon: faCode,
                },
                {
                    id: 4,
                    startTime: '2023-10-20T12:00:00',
                    endTime: '2023-10-20T13:30:00',
                    description: 'Entertainment Break - Scavenger Hunt',
                    icon: faPuzzlePiece,
                },
                {
                    id: 5,
                    startTime: '2023-10-20T19:00:00',
                    // endTime: '2023-10-20T19:00:00',
                    description: 'Pizza Time',
                    icon: faPizzaSlice,
                },
                {
                    id: 6,
                    startTime: '2023-10-20T00:00:00',
                    description: 'Coding all night long',
                    icon: faCode,
                },
            ],
            saturday: [
                {
                    id: 0,
                    startTime: '2023-10-21T09:00:00',
                    endTime: '2023-10-21T10:00:00',
                    description: 'Kick-off Day 2 & CoBa HR chit chat',
                    icon: faMugHot,
                },
                {
                    id: 1,
                    startTime: '2023-10-21T10:30:00',
                    endTime: '2023-10-21T10:45:00',
                    description: 'Call with other venues',
                    icon: faHeadset,
                },
                {
                    id: 2,
                    startTime: '2023-10-21T14:00:00',
                    endTime: '2023-10-21T17:00:00',
                    description: 'Feedback Sessions',
                    icon: faComments,
                },
                {
                    id: 3,
                    startTime: '2023-10-21T00:00:00',
                    description: 'Coding all night long',
                    icon: faCode,
                },
            ],
            sunday: [
                {
                    id: 0,
                    startTime: '2023-10-22T09:00:00',
                    endTime: '2023-10-22T09:30:00',
                    description: 'Kick-off Day 3',
                    icon: faMugHot,
                },
                {
                    id: 1,
                    startTime: '2023-10-22T10:30:00',
                    endTime: '2023-10-22T12:00:00',
                    description:
                        'Time for Coding and Preparation of Presentations',
                    icon: faFilePowerpoint,
                },
                {
                    id: 2,
                    startTime: '2023-10-22T12:00:00',
                    // endTime: '2023-10-22T12:00:00',
                    description: 'End of Coding',
                    icon: faCode,
                },
                {
                    id: 3,
                    startTime: '2023-10-22T12:15:00',
                    endTime: '2023-10-22T15:00:00',
                    description: 'Presentation of Results',
                    icon: faPersonChalkboard,
                },
                {
                    id: 4,
                    startTime: '2023-10-22T16:00:00',
                    endTime: '2023-10-22T16:30:00',
                    description: 'Announcement of local Winners',
                    icon: faAward,
                },
                {
                    id: 5,
                    startTime: '2023-10-22T16:30:00',
                    endTime: '2023-10-22T17:00:00',
                    description:
                        'Announcement of Grand Prize Winners and Closing',
                    icon: faAward,
                },
            ],
        },
    },
    {
        country: 'Bulgaria',
        schedule: {
            friday: [
                {
                    id: 0,
                    startTime: '2023-10-20T09:30:00',
                    endTime: '2023-10-20T11:00:00',
                    description: 'Registration',
                    icon: faAddressCard,
                },
                {
                    id: 1,
                    startTime: '2023-10-20T11:00:00',
                    endTime: '2023-10-20T12:00:00',
                    description: 'Welcome Speeches and Challenge Presentation',
                    icon: faComment,
                },
                {
                    id: 2,
                    startTime: '2023-10-20T12:00:00',
                    endTime: '2023-10-20T13:30:00',
                    description: 'Start of Coding',
                    icon: faCode,
                },
                {
                    id: 3,
                    startTime: '2023-10-20T13:30:00',
                    endTime: '2023-10-20T14:30:00',
                    description: 'Lunch',
                    icon: faBowlFood,
                },
                {
                    id: 4,
                    startTime: '2023-10-20T15:00:00',
                    endTime: '2023-10-20T16:30:00',
                    description: 'Coding',
                    icon: faCode,
                },
                {
                    id: 5,
                    startTime: '2023-10-20T16:30:00',
                    endTime: '2023-10-20T17:00:00',
                    description: 'Coffee Break with the "Biscuits"',
                    icon: faCookie,
                },
                {
                    id: 6,
                    startTime: '2023-10-20T17:00:00',
                    endTime: '2023-10-20T17:30:00',
                    description: 'Brunch',
                    icon: faBowlFood,
                },
                {
                    id: 6,
                    startTime: '2023-10-20T17:30:00',
                    endTime: '2023-10-20T20:00:00',
                    description: 'Coding',
                    icon: faCode,
                },
            ],
            saturday: [
                {
                    id: 0,
                    startTime: '2023-10-21T08:00:00',
                    // endTime: '2023-10-21T11:30:00',
                    description: 'Restart of Coding',
                    icon: faCloudSun,
                },
                {
                    id: 1,
                    startTime: '2023-10-21T08:30:00',
                    endTime: '2023-10-21T09:00:00',
                    description: 'Breakfast',
                    icon: faBreadSlice,
                },
                {
                    id: 2,
                    startTime: '2023-10-21T09:00:00',
                    endTime: '2023-10-21T11:30:00',
                    description: 'Coding',
                    icon: faCode,
                },
                {
                    id: 3,
                    startTime: '2023-10-21T11:30:00',
                    endTime: '2023-10-21T12:00:00',
                    description: 'Call with all Locations',
                    icon: faHeadset,
                },
                {
                    id: 4,
                    startTime: '2023-10-21T12:00:00',
                    endTime: '2023-10-21T13:30:00',
                    description: 'Coding',
                    icon: faCode,
                },
                {
                    id: 5,
                    startTime: '2023-10-21T13:30:00',
                    endTime: '2023-10-21T14:30:00',
                    description: 'Lunch',
                    icon: faBowlFood,
                },
                {
                    id: 6,
                    startTime: '2023-10-21T14:30:00',
                    endTime: '2023-10-21T17:00:00',
                    description: 'Coding',
                    icon: faCode,
                },
                {
                    id: 7,
                    startTime: '2023-10-21T15:00:00',
                    endTime: '2023-10-21T16:00:00',
                    description: 'Bowling (Optional)',
                    icon: faBowlingBall,
                },
                {
                    id: 8,
                    startTime: '2023-10-21T17:00:00',
                    endTime: '2023-10-21T20:00:00',
                    description: 'Coding',
                    icon: faCode,
                },
            ],
            sunday: [
                {
                    id: 0,
                    startTime: '2023-10-22T08:00:00',
                    // endTime: '2023-10-21T11:30:00',
                    description: 'Restart of Coding',
                    icon: faCloudSun,
                },
                {
                    id: 1,
                    startTime: '2023-10-22T08:30:00',
                    endTime: '2023-10-22T09:00:00',
                    description: 'Breakfast',
                    icon: faBreadSlice,
                },
                {
                    id: 2,
                    startTime: '2023-10-22T09:00:00',
                    endTime: '2023-10-22T13:00:00',
                    description: 'Coding',
                    icon: faCode,
                },
                {
                    id: 3,
                    startTime: '2023-10-22T13:00:00',
                    // endTime: '2023-10-21T21:00:00',
                    description: 'End of Coding ',
                    icon: faFlagCheckered,
                },
                {
                    id: 4,
                    startTime: '2023-10-22T13:00:00',
                    endTime: '2023-10-22T14:00:00',
                    description: 'Lunch',
                    icon: faBowlFood,
                },
                {
                    id: 5,
                    startTime: '2023-10-22T14:00:00',
                    endTime: '2023-10-22T16:00:00',
                    description: 'Team Presentation and Pitching of Solutions',
                    icon: faPersonChalkboard,
                },
                {
                    id: 6,
                    startTime: '2023-10-22T16:00:00',
                    endTime: '2023-10-22T17:00:00',
                    description: 'Jury Evaluation & Coffee Pause',
                    icon: faUsersLine,
                },
                {
                    id: 7,
                    startTime: '2023-10-22T17:00:00',
                    endTime: '2023-10-22T17:30:00',
                    description: 'Announcement of Winners',
                    icon: faAward,
                },
                {
                    id: 8,
                    startTime: '2023-10-22T17:30:00',
                    endTime: '2023-10-22T18:00:00',
                    description: 'Official Closing Ceremony',
                    icon: faCrown,
                },
            ],
        },
    },
    {
        country: 'CzechRepublic',
        schedule: {
            friday: [
                {
                    id: 0,
                    startTime: '2023-10-20T09:00:00',
                    endTime: '2023-10-20T09:30:00',
                    description: 'Registration',
                    icon: faAddressCard,
                    location: 'National Library of Technology',
                },
                {
                    id: 1,
                    startTime: '2023-10-20T09:45:00',
                    endTime: '2023-10-20T10:15:00',
                    description: 'Introduction & Welcome Speeches',
                    icon: faComment,
                },
                {
                    id: 2,
                    startTime: '2023-10-20T10:15:00',
                    endTime: '2023-10-20T11:00:00',
                    description: 'Infrastructure & Setup',
                    icon: faScrewdriverWrench,
                },
                {
                    id: 3,
                    startTime: '2023-10-20T11:00:00',
                    // endTime: '2023-10-20T00:00:00',
                    description: 'Start of Coding (open end)',
                    icon: faCode,
                    location: 'Fakulta informačních technologií ČVUT',
                },
                {
                    id: 5,
                    startTime: '2023-10-20T18:00:00',
                    endTime: '2023-10-20T22:00:00',
                    description: 'Entertainment',
                    icon: faMusic,
                },
            ],
            saturday: [
                {
                    id: 0,
                    startTime: '2023-10-21T09:00:00',
                    endTime: '2023-10-21T10:30:00',
                    description: 'Kick-off Day 2',
                    icon: faMugHot,
                    location: 'Fakulta informačních technologií ČVUT',
                },
                {
                    id: 1,
                    startTime: '2023-10-21T10:30:00',
                    endTime: '2023-10-21T10:45:00',
                    description: 'Call with other venues',
                    icon: faHeadset,
                },
                {
                    id: 2,
                    startTime: '2023-10-21T14:00:00',
                    endTime: '2023-10-21T17:00:00',
                    description: 'Feedback Sessions',
                    icon: faComments,
                },
                {
                    id: 3,
                    startTime: '2023-10-20T18:00:00',
                    // endTime: '2023-10-20T18:00:00',
                    description: 'Entertainment',
                    icon: faMusic,
                },
            ],
            sunday: [
                {
                    id: 0,
                    startTime: '2023-10-22T09:00:00',
                    endTime: '2023-10-22T10:30:00',
                    description: 'Kick-off Day 3',
                    icon: faMugHot,
                    location: 'Fakulta informačních technologií ČVUT',
                },
                {
                    id: 1,
                    startTime: '2023-10-22T10:30:00',
                    endTime: '2023-10-22T12:00:00',
                    description:
                        'Time for Coding and Preparation of Presentations',
                    icon: faFilePowerpoint,
                },
                {
                    id: 2,
                    startTime: '2023-10-22T12:00:00',
                    // endTime: '2023-10-22T12:00:00',
                    description: 'End of Coding',
                    icon: faCode,
                },
                {
                    id: 3,
                    startTime: '2023-10-22T12:15:00',
                    endTime: '2023-10-22T15:00:00',
                    description: 'Presentation of Results',
                    icon: faPersonChalkboard,
                },
                {
                    id: 4,
                    startTime: '2023-10-22T16:00:00',
                    endTime: '2023-10-22T17:00:00',
                    description: 'Announcement of Winners',
                    icon: faAward,
                },
            ],
        },
    },
];
